'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (instance, nextProps, nextState) {
  return !(0, _.isEqual)(instance.props, nextProps) || !(0, _.isEqual)(instance.state, nextState);
};

var _ = require('_');

module.exports = exports['default'];

/**
 * Does a deep comparison for props and state.
 * Similar to React's shallowCompare.
 * Warning: Do not use for deeply nested / complex props or state!!!
 * @param  {React.Component} instance
 * @param  {object} nextProps
 * @param  {object} nextState
 * @return {bool} should component update?
 */


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.493/js/lib/deepCompare.js
// module id = 995
// module chunks = 2 3